import React from 'react';
import { Link } from 'react-router-dom';
import { Thead } from './partials/PopUps.js';
function ItemsProduct(props){
	const { producto, indice } = props;
	return (
		<tr key={indice} className={producto.precio<1?'error':''}>
			<td className="codigo">{producto.codigo}</td>
			<td className="codigo">{producto.devolucion === 'No' ? 'Venta':'Cambio'}</td>
			<td className="producto text-left">{producto.nombre}</td>
			<td className="precio">${producto.precio}</td>
			<td className="existencia">{producto.cantidad}</td>
			<td>${( producto.cantidad * producto.precio)}</td>
		</tr>
	)
}

class Reportes extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			ventas : [],
			sucursalID : '',
			sucursales : [],
			cantidad : 0,
			total : 0,
			columns : ['Código', 'Transacción','Producto', 'Precio','Tot. Uni. Vendidas', 'Total'],
		}
		this.sucursal = [];
	}
	componentDidMount(){
		const fecha = new Date();
		let month = fecha.getMonth() + Number(1);
		month = month < 10 ? '0'+month : month;
		const today = fecha.getFullYear()+'-'+month+'-'+fecha.getDate();
		const sucursalID = this.props.match.params.id;
		const api = window.$api + ( sucursalID ?  '/summarySucursal/'+sucursalID+'/'+today :
												'/ventas');
		fetch(api)
		.then(res=>res.json()).then(
			response => {
				const ventas = response.productos;
				const cantidad = ventas ? ventas.length :0;
				let total = 0;
				if( cantidad > 0 ){
					ventas.forEach( producto =>{
						total += (producto.precio * producto.cantidad);
					});
				}
				this.setState({ventas,cantidad,total});
			},
			error=>{
				console.log(error);
			}
		);
	}
	actived(arg){
		return this.props.match.path === arg ? 'actived' : '';
	}
	render(){
		let list = [];
		let fecha;
		const meses = [
			'Enero','Febrero','Marzo','Abril','Marzo','Mayo','Junio',
			'Julio', 'Agosto', 'Septiembre','Octubre','Noviembre','Diciembre'
		];
		
		if( Array.isArray(this.state.ventas) && this.state.ventas.length ){
			this.state.ventas.forEach((e, index)=>{
				list.push(<ItemsProduct producto={e} key={index}/>);
			});
			fecha = this.state.ventas[0].created_at;
			fecha = fecha.split(' ')[0];
			fecha = fecha.split('-');
			let mes = fecha[1].replace('0', '', fecha[1]);
			fecha = fecha[2]+' de '+meses[mes]+' del '+fecha[0];
		}
		return(
			<div className="wrap-module">
				<h1>Reportes</h1>
				<div className="menuProductos">
					<Link to="/reportegeneral" className="link-green"><i className="icon-right"></i></Link> 
					<Link to="/reportegeneral" className="">Regresar</Link>
				</div>
				<div className="wrap-content">
					<div className="xs-12 sm-12 md-12 lg-12">
						<h3 style={{marginBottom:'0px', color:'#e05f9d'}}>Sucursal {this.sucursal&&this.sucursal.nombre}</h3>
						<p>Fecha de venta {fecha}</p>
					</div>
					<table className="margintop30">
						{ this.state.columns.length > 0 && <Thead columns={this.state.columns}/>}
						<tbody id="bodyReport">{list}</tbody>
						<tfoot>
							<tr>
								<td colSpan="4">
									<strong>Mostrando {this.state.cantidad} de {this.state.cantidad}</strong>
								</td>
								<td><span>Monto Total:</span></td>
								<td className="text-center">
									<strong>{window.$fmoney(this.state.total,2)}</strong>
								</td>
							</tr>
						</tfoot>
					</table>
				</div>
			</div>
		);
	}
}
export default Reportes;